// ============ TIMER ============ 
  // document.addEventListener("DOMContentLoaded", function() {
  //   // Set countdown duration (in seconds) — e.g. 1 day
  //   const countdownDuration = 24 * 60 * 60; // 1 day in seconds

  //   let timeLeft = countdownDuration;

  //   function updateTimer() {
  //     const days = Math.floor(timeLeft / (24 * 60 * 60));
  //     const hours = Math.floor((timeLeft % (24 * 60 * 60)) / 3600);
  //     const minutes = Math.floor((timeLeft % 3600) / 60);
  //     const seconds = Math.floor(timeLeft % 60);

  //     document.getElementById("days").textContent = String(days).padStart(2, "0");
  //     document.getElementById("hours").textContent = String(hours).padStart(2, "0");
  //     document.getElementById("minutes").textContent = String(minutes).padStart(2, "0");
  //     document.getElementById("seconds").textContent = String(seconds).padStart(2, "0");

  //     if (timeLeft <= 0) {
  //       timeLeft = countdownDuration; // Reset timer when it ends
  //     } else {
  //       timeLeft--;
  //     }
  //   }

  //   // Initialize and update every second
  //   updateTimer();
  //   setInterval(updateTimer, 1000);
  // });


// ============ REVIEWS SECTION ============
var reviewsSwiper = new Swiper('.reviews-swiper', {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  autoplay: {
    delay: 5000000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.reviews-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.reviews-button-next',
    prevEl: '.reviews-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 35,
    },
  },
});

// ============ PRODUCT GALLERY ============

document.addEventListener('DOMContentLoaded', function () {
  var gallerySwiper = new Swiper('.gallerySwiper', {
    slidesPerView: 1.2,
    spaceBetween: 16,
    loop: true,
    navigation: {
      nextEl: '.gallery-button-next',
      prevEl: '.gallery-button-prev',
    },
    breakpoints: {
      576: { slidesPerView: 2.2 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 4 },
    },
  });
});



// TABLE OF CONTENT

document.addEventListener("DOMContentLoaded", function() {
  const articleContent = document.querySelector('.article-template__content');
  const tocList = document.getElementById('toc-list');
  const tocWrapper = document.getElementById('toc-wrapper');
  if (!articleContent || !tocList) return;

  // First, look for heading tags (h2, h3, h4)
  let headings = articleContent.querySelectorAll('h2, h3, h4');

  // If no headings found, fall back to bold tags (b or strong)
  if (headings.length === 0) {
    headings = articleContent.querySelectorAll('b, strong');
  }

  // If still nothing found, hide TOC completely
  if (headings.length === 0) {
    tocWrapper.style.display = 'none';
    return;
  }

  // ✅ Build Table of Contents dynamically
  headings.forEach((heading, index) => {
    const id = 'section-' + index;
    heading.setAttribute('id', id);

    const li = document.createElement('li');
    const tag = heading.tagName.toLowerCase();

    // Assign classes for indentation levels
    if (tag === 'h2') li.className = 'toc-item';
    if (tag === 'h3') li.className = 'toc-subitem';
    if (tag === 'h4') li.className = 'toc-subsubitem';
    if (tag === 'b' || tag === 'strong') li.className = 'toc-fallback-item';

    const a = document.createElement('a');
    a.href = '#' + id;
    a.textContent = heading.textContent.trim();
    a.addEventListener('click', (e) => {
      e.preventDefault();
      document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    li.appendChild(a);
    tocList.appendChild(li);
  });
});



// SCROLL CLASS TABLE OF CONTENT
